<p-dialog
  [(visible)]="visibleDialog"
  [modal]="true"
  [resizable]="false"
  [closable]="false"
  [closeOnEscape]="true"
  [draggable]="false"
  [blockScroll]="true"
  (onShow)="onShow()">
  <ng-template pTemplate="header">
    <div class="w-full p-2 sm:p-4 bg-lightest rounded-md">
      <h1 class="white-space-nowrap text-xl flex justify-center font-app-bold text-darkest">
        {{ "modifyPolicy.header" | translate }}
      </h1>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <p-stepper [(activeStep)]="activeIndex">
      <p-stepperPanel [header]="'modifyPolicy.headerPolicy' | translate">
        <ng-template
          pTemplate="content"
          let-nextCallback="nextCallback"
          let-index="index">
          <div class="flex flex-col min-h-48 sm:min-h-64">
            @if (isMrhBranch) {
              <app-contract-edition-foropttarif-mrh
                [policyFieldsVM]="policyFieldsVM"
                [policyDetails]="policyDetails"
                [policyDetailsCopy]="policyDetailsCopy"
                [formulaValues]="formulaValues"
                [nombrePieces]="nombrePieces"
                [isConfort]="isConfort"
                [qualiteOccupant]="qualiteOccupant"
                [hasEndorsementWait4Sign]="hasEndorsementWait4Sign"
                (emitIsSchoolInsuranceSelected)="onIsSchoolInsuranceSelected($event)"
                (emitBailleurHasChanged)="onBailleurHasChanged($event)"
                (emitPjHasChanged)="onIsJuridicProtectionSelected($event)"
                (emitVanHasChanged)="onIsNewValueOptionSelected($event)"
                (emitFormulaChange)="onFormulaChange($event)">
              </app-contract-edition-foropttarif-mrh>
              <app-contract-edition-housing-mrh
                [policyFieldsVM]="policyFieldsVM"
                [policyDetails]="policyDetails"
                [policyDetailsCopy]="policyDetailsCopy"
                [possedePiscine]="possedePiscine"
                [natureLogement]="natureLogement"
                [possedeEnergieV]="possedeEnergieV"
                [qualiteOccupant]="qualiteOccupant"
                [typeHabitation]="typeHabitation"
                [nombrePieces]="nombrePieces"
                [possedeVeranda]="possedeVeranda"
                [nombrePiecesQuarante]="nombrePiecesQuarante"
                [surfaceDependance]="surfaceDependance"
                [etage]="etage"
                [isConfort]="isConfort"
                [hasEndorsementWait4Sign]="hasEndorsementWait4Sign"
                (emitNatureLogement)="onNatureLogementChange($event)"
                (emitQualiteOccupant)="onQualiteOccupantChange($event)"
                (emitNombrePieces)="onNombrePieceChange($event)"
                (emitNombrePiecesQuarante)="onNombrePiecesQuaranteChange($event)"
                (emitSurfaceDependance)="onSurfaceDependanceChange($event)"
                (emitPossedeVeranda)="onPossedeVerandaChange($event)"
                (emitPossedeEnergieV)="onPossedeEnergieVChange($event)"
                (emitPossedePiscine)="onPossedePiscineChange($event)">
              </app-contract-edition-housing-mrh>
              <app-contract-edition-children-mrh
                [policyFieldsVM]="policyFieldsVM"
                [policyDetailsCopy]="policyDetailsCopy"
                [childrenInformations]="childrenInformations"
                [childrenInformationsInitialValue]="childrenInformationsInitialValue"
                [childFirstNameHasChanged]="childFirstNameHasChanged"
                [childLastNameHasChanged]="childLastNameHasChanged"
                [childBirthDateHasChanged]="childBirthDateHasChanged"
                [isSchoolInsuranceSelected]="isSchoolInsuranceSelected"
                [hasEndorsementWait4Sign]="hasEndorsementWait4Sign"
                (emitFormValidity)="onFormValidityChange($event)"
                (emitChildrenInformations)="onChildrenInformationChange($event)"></app-contract-edition-children-mrh>
              <app-contract-edition-lessor-mrh
                [policyFieldsVM]="policyFieldsVM"
                [policyDetails]="policyDetails"
                [policyDetailsCopy]="policyDetailsCopy"
                [lessorData]="lessorData"
                [lessorDataCopy]="lessorDataCopy"
                [lessorList]="lessorList"
                [lessorOptions]="lessorOptions"
                [lessorSocialSelected]="lessorSocialSelected"
                [hasEndorsementWait4Sign]="hasEndorsementWait4Sign"
                (emitFormValidity)="onFormValidityChange($event)">
              </app-contract-edition-lessor-mrh>
            }

            <!-- Contrat detail -->
            <app-contract-detail-sa-contract-informations
              *ngIf="isSaBranch"
              [policyFieldsVM]="policyFieldsVM"
              [policyDetails]="policyDetails"
              [policyDetailsCopy]="policyDetailsCopy"
              (emitFormValidityChange)="onFormValiditySAChange($event)"></app-contract-detail-sa-contract-informations>
            <!--Information de paiment-->
            <app-contract-edition-payment-informations
              [policyFieldsVM]="policyFieldsVM"
              [policyDetails]="policyDetails"
              [policyDetailsCopy]="policyDetailsCopy"
              [fractionationOptions]="fractionationOptions"
              [memberCopy]="memberCopy"
              [hasEndorsementWait4Sign]="hasEndorsementWait4Sign"
              (emitFormValidity)="onFormValidityChange($event)"
              (emitOnPaymentIbanBlur)="onPaymentIbanBlur()"></app-contract-edition-payment-informations>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- Données personnelles -->
      <p-stepperPanel [header]="'modifyPolicy.headerPersonalData' | translate">
        <ng-template
          pTemplate="content"
          let-prevCallback="prevCallback"
          let-nextCallback="nextCallback"
          let-index="index">
          <div class="flex flex-col min-h-48 sm:min-h-64 min-w-[40rem]">
            <app-personal-data
              [policyFieldsVM]="policyFieldsVM"
              [phonePrefixes]="phonePrefixes"
              [selectedPhonePrefix]="selectedPhonePrefix"
              [member]="member"
              [memberCopy]="memberCopy"
              [countriesOptions]="countriesOptions"
              [hasEndorsementWait4Sign]="hasEndorsementWait4Sign"
              (emitFormValidity)="onFormValidityChange($event)"
              (emitPhoneMask)="onPhoneMaskChange($event)"
              (emitCountryHasChange)="onCountryHasChange($event)"
              (emitNationalityHasChange)="onNationalityHasChange($event)"
              (emitPhoneNumberHasChange)="onPhoneNumberHasChange($event)"
              (emitPhonePrefixHasChange)="onPhonePrefixHasChange($event)"></app-personal-data>
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel [header]="'modifyPolicy.headerConfirmation' | translate">
        <ng-template
          pTemplate="content"
          let-prevCallback="prevCallback"
          let-index="index">
          <div class="flex flex-col min-h-48 sm:min-h-64">
            <app-contract-changes
              #changes
              [policyChangeLog]="policyChangeLog"
              [reference]="policyDetailsCopy.reference"
              [displaySignaturePhone]="displaySignaturePhone"
              [phoneNumber]="selectedSignaturePhoneNumber"
              [phonePrefix]="selectedSignaturePhonePrefix"
              [phonePrefixes]="phonePrefixes"
              [multicontract]="hasMemberMultipleReferences"
              (signaturePhonePrefixChange)="onSignaturePhonePrefixChange($event)"
              (signaturePhoneNumberChange)="onSignaturePhoneNumberChange($event)"
              (signaturePhoneSignatureCheckboxChange)="
                onSignaturePhoneSignatureCheckBoxChange($event)
              "></app-contract-changes>
          </div>
        </ng-template>
      </p-stepperPanel>
    </p-stepper>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-4 pt-4 sm:pt-8">
      <button
        pButton
        type="button"
        [label]="getCancelButtonLabel()"
        class="bg-white border-primary border-solid border-[1px] w-full sm:w-1/3 md:w-1/4 p-1 text-primary"
        (click)="cancelStep()"></button>
      <button
        pButton
        type="button"
        [label]="getContractLabel()"
        class="bg-primary text-white w-full sm:w-1/3 md:w-1/4 p-1"
        [loading]="loading"
        [disabled]="
          (!isFormValid[activeIndex] && activeIndex !== getCurrentStep(0)) ||
          (activeIndex === getCurrentStep(1) && !hasChanged())
        "
        (click)="validateStep()"></button>
    </div>
  </ng-template>
</p-dialog>
<app-lessor-dialog
  [visible]="isLessorDialogVisible"
  [data]="lessorDataCopy"
  [productCode]="policyDetailsCopy.productCode"
  (visibleChange)="onLessorDialogClose($event)">
</app-lessor-dialog>
<app-contract-edition-iban
  [isVisible]="isIbanDialogVisible"
  [hasMemberMultipleReferences]="hasMemberMultipleReferences"
  (isVisibleChange)="onIbanDialogClose($event)">
</app-contract-edition-iban>
<app-ok-dialog
  *ngIf="isIbanErrorDialogVisible"
  message="{{ 'paymentInfo.ibanNotOwnerMessage' | translate }}"
  title="{{ 'paymentInfo.ibanNotOwnerTitle' | translate }}"
  okLabel="{{ 'terminationConditions.CloseButton' | translate }}"
  (visibleChange)="onIsIbanErrorDialogClose()">
</app-ok-dialog>
<app-ok-dialog
  *ngIf="IsIbanInvalidDialogVisible"
  message="{{ 'paymentInfo.ibanErrorTitle' | translate }}"
  title="{{ 'paymentInfo.ibanErrorTitle' | translate }}"
  okLabel="{{ 'common.ok' | translate }}"
  (visibleChange)="onIsIbanInvalidDialogClose()">
</app-ok-dialog>
<app-ok-dialog
  *ngIf="IsCallInErrorDialogVisible"
  message="{{ 'common.errorMessage' | translate }}"
  title="{{ 'common.errorMessageTitle' | translate }}"
  okLabel="{{ 'common.ok' | translate }}"
  (visibleChange)="onCallInErrorDialogVisible()">
</app-ok-dialog>
<app-ok-dialog
  *ngIf="IsSaveDialogVisible"
  message="{{ 'common.saveMessage' | translate }}"
  title="{{ 'common.saveMessageTitle' | translate }}"
  okLabel="{{ 'common.ok' | translate }}"
  [cancelButton]="true"
  (closeDialogEvent)="onSaveDialogClose($event)">
</app-ok-dialog>
